import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Modal from 'simple-react-modal';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import classnames from 'classnames';

import VideoPlayer from '../../blogComponents/SimpleVideoPlayer';
import { ANCHOR_VIDEOS_ARCHIVE_VIDEO, ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO } from '../../../constants/apiUrls/apiUrls';
import callApi from '../../../utils/callApi';
import NotificationStore from '../../../store/NotificationStore';
import PayPerViewStore from '../../../store/PayPerViewStore';
import { anchorIsNakedNewsLive, buildAnchorCheckoutLink, buildAnchorLink } from '../../../utils/helpers';

import './PrivateVideo.css';
import LiveEventsContent from './PrivateContentComponents/LiveEventsContent';
import {
  linkToPaymentPage,
  LockIcon,
  PlayIcon,
  PriceForClipStoreItem,
} from './PrivateContentComponents/PrivateContentUtils';
import PrivateContentDescription from './PrivateContentComponents/PrivateContentDescription';


class PrivateVideo extends React.Component {
  constructor(props) {
    super(props);
    const { video } = props;
    const { anchorId } = video;

    this.state = {
      showModal: false,
      privateVideo: null,
      showPayPerViewModal: false,
      anchorShortUrl: '',
      shouldBlurContent: true,
      userCanAccessContent: false,
      isBanned: false,
    };
  }

  componentDidMount() {
    const anchor = this.getCurrentAnchor();
    this.setBlurringForContent(anchor);
    this.setBanStatus(anchor);
    this.checkIfUserCanAccessContent();
    this.buildAnchorShortUrl(anchor);
  }

  buildAnchorShortUrl = () => {
    this.setState({ anchorShortUrl: buildAnchorLink({ id: this.props.anchorId, name: this.getCurrentAnchor?.()?.name }) })
  }

  getCurrentAnchor = () => this.props.anchors?.find((anchor) => anchor.id === this.props.video?.anchorId);

  componentDidUpdate(prevProps, prevState) {
    const isNakedNewsLivePage = window.location.pathname === '/live';
    if (prevProps.video.anchorId !== this.props.video.anchorId) {
      const anchorData = this.getCurrentAnchor();
      this.setBlurringForContent(this.props.video.anchorId || this.props.anchorId);
      this.setState({
        anchorShortUrl: buildAnchorLink({
          id: isNakedNewsLivePage ? 241 : this.props.anchorId,
          name: anchorData?.name,
        }),
      });
    }
    if (PayPerViewStore.newItemWasPurchased && this.props.selectedClipPrice.id === this.props.video.id) {
      this.fetchVideo(this.props.anchorId, this.props.video.id);
      PayPerViewStore.setNewItemWasPurchased(false);
    }
  }

  checkIfUserCanAccessContent = () => {
    const { payPerViewNav, typeOfListing, user, isClipStorePage } = this.props;
    const isClipStoreTab = payPerViewNav === 'New' && typeOfListing === 'clipstore';
    const { authenticated } = user || {};
    if (!this.state.isBanned && (isClipStorePage || isClipStoreTab) && authenticated) {
      this.setState({ userCanAccessContent: true });

      return true;
    }

    return false;
  };

  setBanStatus = (anchor) => {
    const { user, anchorId } = this.props;
    const { anchorSubscriptions } = user?.user?.account || {};
    const anchorID = anchor?.id || anchorId;
    if (anchorSubscriptions) {
      const subscribedToAnchor = anchorSubscriptions.filter((anchorData) =>
        parseInt(anchorData.subCategory, 10) === anchorID);
      const userIsBanned = subscribedToAnchor?.[0]?.isBanned;
      this.setState({ isBanned: userIsBanned });
    }
  };

  setBlurringForContent = (currentAnchor) => {
    const { anchorId, typeOfListing, isPurchasedTab } = this.props;
    const id = currentAnchor?.id || anchorId;
    if (anchorIsNakedNewsLive(id) || typeOfListing === 'fanzone' || isPurchasedTab) {
      this.setState({ shouldBlurContent: false });
    }
  };

  getAnchorId = (anchId, anchorId) => {
    if (anchId) {
      return anchId;
    }

    return anchorId;
  };

  fetchVideo = (anchId, videoId) => {
    const { anchorId, video, typeOfListing } = this.props;

    const id = this.getAnchorId(video.anchorId, anchorId);

    const vidId = videoId ? videoId : video.id;

    const url = (typeOfListing !== 'clipstore') ? ANCHOR_VIDEOS_ARCHIVE_VIDEO : ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO;

    const privateGalleriesUrl = url.
      replace('{id}', encodeURIComponent(id)).
      replace('{videoId}', encodeURIComponent(vidId));

    callApi(privateGalleriesUrl, 'GET', undefined, undefined, undefined, true, true, true).
      then((res) => {
        const privateVideo = {
          ...res.data,
          imageUrl: res.data.snapshotUrl,
        };
        this.setState({ privateVideo, showModal: true });
      }).
      catch((error) => {
        console.error(error);
      });
  };

  openModal = () => {
    const { isBanned, typeOfListing, openPayPerViewModal, price, video, title } = this.props;

    if (this.props.payPerViewNav === 'New' && typeOfListing === 'clipstore' && !isBanned) {
      openPayPerViewModal(price, title, video.id, 'VIDEO');
      PayPerViewStore.setCurrentlySelectedAnchor(video.anchorName);
    } else if (isBanned) {
      NotificationStore.error('Banned from following this model. Please contact support.');
    } else {
      this.fetchVideo();
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  getGalleryItemLink = () => {
    const { anchorId, subscribed, typeOfListing, isPurchasedTab, isClipStorePage } = this.props;
    const { anchorShortUrl, userCanAccessContent } = this.state;

    if ((isPurchasedTab || (typeOfListing === 'clipstore' && subscribed)) && !isClipStorePage) {
      return '?filter=clipstore';
    } else if (userCanAccessContent || subscribed) {
      return '#';
    }

    return linkToPaymentPage(subscribed, anchorId, anchorShortUrl);
  };

  sentToAcordingLink = () => {
    const { anchorId, subscribed, anchorShortUrl } = this.props;
    if (subscribed) {
      return `/${anchorShortUrl}`;
    }

    return buildAnchorCheckoutLink(anchorId, anchorShortUrl);
  };

  openClipStorePaymentModal = () => {
    const {
      price,
      video,
      title,
      customPriceForFanPlus,
    } = this.props;
    this.props.openPayPerViewModal(price, title, video.id, video.type, customPriceForFanPlus);
    PayPerViewStore.setCurrentlySelectedAnchor(video.anchorName);
    PayPerViewStore.setCurrentlySelectedAnchorID(video.anchorId);
  };

  handleContentClick = () => {
    const { userCanAccessContent, isBanned } = this.state;
    const { isPurchasedTab, user, typeOfListing, payPerViewNav } = this.props;
    const canAccessClipStore = !isBanned &&
      payPerViewNav === 'New' && typeOfListing === 'clipstore' && user.authenticated;

    if (isBanned) {
      NotificationStore.error('Banned from following this model. Please contact support.');
    } else if ((userCanAccessContent || canAccessClipStore) && !isPurchasedTab) {
      this.openClipStorePaymentModal();
    } else {
      this.openModal();
    }
  };

  render() {
    const { showModal, privateVideo, shouldBlurContent } = this.state;
    const {
      video,
      subscribed,
      user,
      title,
      coverPhoto,
      date,
      showDescription = true,
      isBanned,
      needClasses = false,
      videoClass,
      liveEvents = false,
      typeOfListing,
      price,
      payPerViewNav,
    } = this.props;
    const time = moment.utc(video.durationInMs).format('HH : mm : ss');
    const isLocked = (!subscribed || isBanned) && typeOfListing !== 'clipstore';

    if (liveEvents) {
      return (
        <div className="content-item-container">
          <LiveEventsContent
            coverPhoto={coverPhoto}
            isLiveEventsSection={liveEvents}
            linkToDirectTo={this.sentToAcordingLink()}
            shouldBlurContent={shouldBlurContent}
          />
        </div>
      );
    }

    return (
      <div className="content-item-container">
        <Link
          className="content-item gallery-item"
          to={this.getGalleryItemLink()}
          onClick={this.handleContentClick}
        >
          <div
            className={classnames({
              'content-item-thumbnail': true,
              'private-video-thumbnail': true,
              'private-video-thumbnail-trending': needClasses,
            })}
          >
            <div
              className={classnames({
                'private-video-content-preview': true,
                'blur': shouldBlurContent,
              })}
              style={{ background: `url(${coverPhoto}) no-repeat center center / cover` }}
            >
              <div
                alt="anchor-logo"
                className="anchor-side-pic"
                style={{ backgroundImage: `url(${this.state.anchorSidePic}` }}
              />
            </div>
            <div className="private-video-content-after-overlay" />
            <div className="private-video-details">
              <PlayIcon />
              <PriceForClipStoreItem
                payPerViewNav={payPerViewNav}
                price={price}
              />
            </div>
            <LockIcon isLocked={isLocked} />
            {video.durationInMs &&
              <div className="private-video-time-icon">
                <AccessTimeIcon />
                {time}
              </div>
            }
          </div>
          <PrivateContentDescription
            leftTitle={moment(date).format('dddd, MMM DD, YYYY')}
            media={video}
            shouldShowDescription={showDescription}
            title={title}
          />
        </Link>
        <Modal
          containerClassName="private-video-modal"
          show={showModal}
          onClose={() => this.setState({ showModal: false })}
        >
          <VideoPlayer
            autoPlayVideo={true}
            clip={privateVideo}
            user={user}
            videoClass={videoClass}
          />
          <div className="private-video-modal-caption">
            <div className="private-video-modal-title">
              {video.title}
            </div>
            <span className="private-gallery-image-count">{moment(video.date).format('dddd, MMM DD, YYYY')}</span>
            <div className="private-video-modal-description">
              {video.description}
            </div>
            <button className="btn btn-red private-video-close" onClick={this.closeModal}>Close</button>
          </div>
        </Modal>
      </div>
    );
  }
}


export default PrivateVideo;
